{
  "comment": "Mission 1 comms (S12 owns). Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. m1.lead: the scrapyard with the offer (the decoded lead). m1.crew: Tethys Asset Recovery on arrival at the field. m1.bounty.<choice>: the bounty fork's cost text, shown before commit (spec §1 rule 3: \"Your copy won't hold up at a hearing.\"); the amount is leverage.ts's offer, shown by the fork UI beside it. m1.sold, m1.decoded: after the fork and the decode. Nobody states a conclusion (spec §1 rule 2): the scrapyard opens the recorder and stops. Names are placeholders (spec §15 item 7).",
  "nodes": [
    {
      "id": "m1.lead",
      "speaker": "mutualScrapyard",
      "lines": [
        "Your core's open. Queue board fragment, eleven days of it. Last line's a transponder fix: Column Nine's lead hauler, out in the deep.",
        "If the recorder's still in that hull, bring it here. Reading it costs a fee. What's on it is yours."
      ],
      "replies": [
        { "id": "ok", "text": "I'll find it." },
        { "id": "why", "text": "Why would anyone leave a recorder out there?", "next": "m1.lead.why" }
      ]
    },
    {
      "id": "m1.lead.why",
      "speaker": "mutualScrapyard",
      "lines": ["Nobody pays to tow settler hulls. Fifty years, and the field's still on the charts as debris."],
      "replies": [{ "id": "ok", "text": "Noted." }]
    },
    {
      "id": "m1.crew",
      "speaker": "assetRecovery",
      "lines": [
        "Tethys Asset Recovery. This field is company property under salvage claim TMC-AR 10-209.",
        "Hulls, cargo and records. Stand clear of the work."
      ],
      "replies": [
        { "id": "ok", "text": "Noted." },
        { "id": "settlers", "text": "The settler hulls too?", "next": "m1.crew.settlers" }
      ]
    },
    {
      "id": "m1.crew.settlers",
      "speaker": "assetRecovery",
      "lines": ["The claim covers every hull in the queue. Stand clear."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m1.bounty.keep",
      "speaker": "assetRecovery",
      "lines": [
        "Decline the bounty. The recorder stays sealed in your hold until the Mutual opens it.",
        "Asset Recovery logs your registry against the claim."
      ],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m1.bounty.sell_cash",
      "speaker": "assetRecovery",
      "lines": [
        "Return the recorder unopened. The bounty is paid to your account. The original leaves the field for good; you keep a partial copy.",
        "Your copy won't hold up at a hearing. Tethys will know your name."
      ],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m1.bounty.sell_waived",
      "speaker": "assetRecovery",
      "lines": [
        "Return the recorder unopened. Your next lease payments are waived instead of cash. It doesn't clear the lease. You keep a partial copy.",
        "Your copy won't hold up at a hearing. Tethys will know your name."
      ],
      "replies": [{ "id": "ok", "text": "Understood." }]
    },
    {
      "id": "m1.sold",
      "speaker": "assetRecovery",
      "lines": ["Received, seal intact. Payment is on your account.", "Tethys Asset Recovery thanks you for your cooperation."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    },
    {
      "id": "m1.decoded",
      "speaker": "mutualScrapyard",
      "lines": [
        "Recorder's open. Queue log, all eleven days, and an authorisation column.",
        "We don't read them for you. Fee's on your account. The field goes on our charts as a grave now, not debris."
      ],
      "replies": [
        { "id": "ok", "text": "Thanks." },
        { "id": "who", "text": "Who signs as OPS-R/7?", "next": "m1.decoded.who" }
      ]
    },
    {
      "id": "m1.decoded.who",
      "speaker": "mutualScrapyard",
      "lines": ["Not a name we've got. It's a desk code. Someone had the desk."],
      "replies": [{ "id": "ok", "text": "(close the channel)" }]
    }
  ]
}
